import { render, staticRenderFns } from "./BoxSideMenu.vue?vue&type=template&id=a382c820&"
import script from "./BoxSideMenu.vue?vue&type=script&lang=js&"
export * from "./BoxSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports